import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HorizontalMenu from '../components/common/horizontalMenu';
import Breadcrumbs from '../components/common/breadcrumbs';
import { Account } from './accountType';
import AccountApi from './accountApi';
import { getAccountIdFromSessionStorage } from '../lib/global_function';
import { Edit } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Alert } from '../components/ui/alert';
import { CircleUser } from 'lucide-react';



const AccountPage: React.FC = () => {
  const breadcrumbs = [
    { label: 'Account', path: '/main/account' },
  ];

  const [account, setAccount] = useState<Account | null>(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAccount = async () => {
      const accountId = getAccountIdFromSessionStorage((process.env.REACT_APP_SESSION_STORAGE_KEY as string));
      if (!accountId) {
        setErrorMessage('Account ID not available.');
        setLoading(false);
        return;
      }

      try {
        const response = await AccountApi.getAccount(accountId);
        setAccount(response);
      } catch (error) {
        if (error instanceof Error) {
          setErrorMessage(error.message);
        } else {
          setErrorMessage('An unknown error occurred.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAccount();
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    navigate('/main/account/update', { state: { account: account } });
  };

  return (
    <>
      <HorizontalMenu />
      <div className="container-safe py-6">
        <Breadcrumbs items={breadcrumbs} />

        <form onSubmit={handleSubmit}>
         
            <h2 className="text-2xl font-semibold text-foreground mb-2 flex items-center gap-2">
              <CircleUser className="size-7 text-primary" />
              Your Online Account
            </h2>



          {errorMessage && (
            <Alert variant="error">
              {errorMessage}
            </Alert>
          )}


            

             <div className="bg-white rounded-2xl border-2 border-muted p-6 shadow-card">


              <div>
                <strong className="text-foreground font-semibold">First Name:</strong>{' '}
                <span className="text-foreground">{account?.first_name}</span>
              </div>

              <div>
                <strong className="text-foreground font-semibold">Last Name:</strong>{' '}
                <span className="text-foreground">{account?.last_name}</span>
              </div>

              <div>
                <strong className="text-foreground font-semibold">Phone:</strong>{' '}
                <span className="text-foreground">{account?.phone || 'N/A'}</span>
              </div>

              <div>
                <strong className="text-foreground font-semibold">Email:</strong>{' '}
                <span className="text-foreground">{account?.email}</span>
              </div>

              <div>
                <strong className="text-foreground font-semibold">Login ID:</strong>{' '}
                <span className="text-foreground">{account?.login_id}</span>
              </div>
            </div>

          <p>&nbsp;</p>
          <Button type="submit" size="medium" variant="default">
            <Edit className="size-5" />
            Edit
          </Button>
        </form>

        <div className="mb-[150px]"></div>
      </div>
    </>
  );
};

export default AccountPage;